import { ToastProps } from '../components';
import { useStore } from '../context/store';

export const useGlobalToast = () => {
  const [toastStore, toastStoreActions] = useStore<ToastProps>('global-toast-props', {
    isVisible: false,
    onClose: () => {},
    title: '',
  });
  const { data: toastProps } = toastStore;

  const showSuccessToast = (title: string, Icon?: React.FunctionComponent) => {
    toastStoreActions.setValue({
      autoClose: true,
      isVisible: true,
      title,
      onClose: () => {},
      type: 'success',
      icon: Icon ? <Icon /> : undefined,
    });
  };
  const showErrorToast = (title: string, Icon?: React.FunctionComponent) => {
    toastStoreActions.setValue({
      isVisible: true,
      title,
      onClose: () => {},
      type: 'error',
      icon: Icon ? <Icon /> : undefined,
    });
  };
  const showToast = (title: string, Icon?: React.FunctionComponent) => {
    toastStoreActions.setValue({
      isVisible: true,
      title,
      onClose: () => {},
      icon: Icon ? <Icon /> : undefined,
    });
  };

  const onCloseGlobalToast = () => {
    toastProps?.onClose();
    toastStoreActions.reset();
  };

  return {
    toastProps: { ...toastProps, onClose: onCloseGlobalToast },
    showSuccessToast,
    showErrorToast,
    showToast,
  };
};
